const INC = "INC";
const DEC = "DEC";

const badgeInc = (count) => ({
  type: INC,
  preloader: count,
});
const badgeDec = (count) => ({
  type: DEC,
  preloader: count,
});

export { INC, DEC, badgeDec, badgeInc };
